import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { create } from "../../api/API";

const VerifyEmail = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [showResend, setShowResend] = useState(false);
  const [email, setEmail] = useState("");
  const [resending, setResending] = useState(false);

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get("token");

    if (!token) {
      setError("Invalid verification link.");
      setShowResend(true);
      setLoading(false);
      return;
    }

    const verifyEmail = async () => {
      try {
        const res = await create(`/members/verify/${token}`);

        if (res.message === "Account verified successfully.") {
          toast.success("Email verified successfully!");
          setSuccess(true);
        } else {
          throw new Error("Verification failed");
        }
      } catch (err) {
        setError("Invalid or expired verification link.");
        setShowResend(true);
        toast.error("Invalid or expired verification link.");
      } finally {
        setLoading(false);
      }
    };

    verifyEmail();
  }, [searchParams]);

  const handleResend = async () => {
    if (!email) return toast.error("Please enter your email.");

    try {
      setResending(true);
      await create("/members/resend-verification", { email }); // Backend endpoint must exist
      toast.success("Verification email resent! Please check your inbox.");
      setShowResend(false);
    } catch (err) {
      toast.error(
        err.response?.data?.message ||
          err.response?.data?.errors?.[0]?.message ||
          "Failed to resend verification."
      );
    } finally {
      setResending(false);
    }
  };

  return (
    <div
      className="auth-page"
      style={{
        backgroundImage: `url("../assets/images/loginsignbg.png")`,
      }}
    >
      <div className="auth-box bg-white p-8 rounded-lg shadow-md text-center w-full max-w-md">
        {loading && <p>Verifying your email...</p>}

        {!loading && success && (
          <>
            <h2 className="text-2xl font-bold mb-4">Email Verified!</h2>
            <p>Your account has been successfully verified.</p>
            <button
              className="auth-btn bg-primary text-white mt-6"
              onClick={() => navigate("/login")}
            >
              Go to Login
            </button>
          </>
        )}

        {!loading && error && (
          <>
            <h2 className="text-2xl font-bold mb-4 text-red-600">
              Verification Failed
            </h2>
            <p>{error}</p>

            {showResend && (
              <>
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="auth-input mt-4"
                />
                <button
                  className="auth-btn bg-primary text-secondary mt-4"
                  onClick={handleResend}
                  disabled={resending}
                >
                  {resending ? "Resending..." : "Resend Verification Email"}
                </button>
              </>
            )}

            <button
              className="auth-btn bg-gray-300 text-black mt-4"
              onClick={() => navigate("/login")}
            >
              Go to Login
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
